/**
 * Authentication API Service
 * All authentication-related API calls
 */
import axios from 'axios';

const BASE_URL = process.env.VUE_APP_BE_APP_BASE_URL || 'http://localhost:2121';

/**
 * Register new user
 * @param {Object} userData 
 * @param {string} userData.username
 * @param {string} userData.email
 * @param {string} userData.password
 * @param {string} userData.full_name
 * @returns {Promise<Object>}
 */
export async function register(userData) {
    const response = await axios.post(`${BASE_URL}/register`, {
        username: userData.username,
        email: userData.email,
        password: userData.password,
        full_name: userData.full_name
    });
    return response.data;
}

/**
 * Login user
 * @param {string} username 
 * @param {string} password 
 * @returns {Promise<Object>}
 */
export async function login(username, password) {
    const response = await axios.post(`${BASE_URL}/login`, {
        username,
        password
    });
    return response.data;
}

/**
 * Logout user
 * @param {string} refreshToken 
 * @returns {Promise<Object>}
 */
export async function logout(refreshToken) {
    const response = await axios.post(`${BASE_URL}/api/logout`, {
        refresh_token: refreshToken
    }, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
        }
    });
    return response.data;
}

/**
 * Refresh access token
 * @param {string} refreshToken 
 * @returns {Promise<Object>}
 */
export async function refreshToken(refreshToken) {
    const response = await axios.post(`${BASE_URL}/refresh`, {
        refresh_token: refreshToken
    });
    return response.data;
}

/**
 * Get current user profile
 * @returns {Promise<Object>}
 */
export async function getProfile() {
    const response = await axios.get(`${BASE_URL}/api/me`, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
        }
    });
    return response.data;
}

/**
 * Update user profile
 * @param {Object} profileData 
 * @param {string} profileData.full_name
 * @param {string} profileData.avatar_url
 * @returns {Promise<Object>}
 */
export async function updateProfile(profileData) {
    const response = await axios.put(`${BASE_URL}/api/me`, profileData, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
        }
    });
    return response.data;
}

/**
 * Change user password
 * @param {string} oldPassword 
 * @param {string} newPassword 
 * @returns {Promise<Object>}
 */
export async function changePassword(oldPassword, newPassword) {
    const response = await axios.put(`${BASE_URL}/api/me/password`, {
        old_password: oldPassword,
        new_password: newPassword
    }, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
        }
    });
    return response.data;
}
/**
 * Upload user avatar
 * @param {File} file 
 * @returns {Promise<Object>}
 */
export async function uploadAvatar(file) {
    const formData = new FormData();
    formData.append('avatar', file);

    const response = await axios.post(`${BASE_URL}/api/me/avatar`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
        }
    });
    return response.data;
}
